import { render } from "./Morosità.vue?vue&type=template&id=60c0ff1c&scoped=true"
import script from "./Morosità.vue?vue&type=script&lang=js"
export * from "./Morosità.vue?vue&type=script&lang=js"

import "./Morosità.vue?vue&type=style&index=0&id=60c0ff1c&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c0ff1c"]])

export default __exports__